<template>
  <div>
    <div style="border: 1px solid #ccc; margin-top: 10px">
      <!-- 工具栏 -->
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
      />
      <!-- 编辑器 -->
      <Editor
        style="height: 150px; overflow-y: hidden"
        :defaultConfig="editorConfig"
        v-model="html"
        :mode="mode"
        @onChange="onChange"
        @onCreated="onCreated"
      />
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
export default {
  name: "MyEditor",
  components: { Editor, Toolbar },
  props: {
    deHtml: {
      default: ""
    }
  },
  data() {
    return {
      editor: null,
      html: "",
      mode: "simple",
      toolbarConfig: {
        toolbarKeys: [
          "header1",
          "|",
          "bold",
          "underline",
          "indent",
          "color",
          "bgColor",
          "clearStyle",
          "|",
          "bulletedList",
          "numberedList",
          "justifyLeft",
          "justifyRight",
          "justifyCenter",
          "|",
          "insertLink",
          "|",
          "undo",
          "redo",
          "|",
          "fullScreen"
        ],
        hoverbarKeys: ["bold"]
      },
      editorConfig: {
        placeholder: "Enter...",
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {}
      }
    };
  },
  watch: {
    deHtml(news) {
      this.html = news;
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    onChange(editor) {
      this.html = editor.getHtml();
      this.$emit("editorChange", this.html);
      console.log("onChange", editor.getHtml()); // onChange 时获取编辑器最新内容
    },
    getEditorText() {
      const editor = this.editor;
      if (editor == null) return;
      return editor.getHtml();
    }
  },
  mounted() {
    this.html = this.deHtml;
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
  }
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
